import { render } from "./home_full_width.vue?vue&type=template&id=090a9c1e&scoped=true"
import script from "./home_full_width.vue?vue&type=script&lang=js"
export * from "./home_full_width.vue?vue&type=script&lang=js"

import "./home_full_width.vue?vue&type=style&index=0&id=090a9c1e&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090a9c1e"]])

export default __exports__